module.exports = flarum.core.compat['forum/suspend/components/suspendUserModal'];